export default "__VITE_ASSET__D72SkVMo__"